import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { classNames } from 'support/helpers/generic/generic';
import { NavigationLink, NavigationLinkGroup } from 'components/Page/types';

type SecondaryNavigationItemProps = {
  href: string;
  label: ReactNode;
  onClick?: () => void;
};

const getLinkClasses = ({ isActive }: { isActive: boolean }) =>
  classNames(
    isActive ? 'bg-gray-200 text-gray-900' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
    'px-3 py-2 font-medium rounded-md text-sm group relative rounded-md',
  );

const SecondaryNavigationItem = ({ href, label, onClick }: SecondaryNavigationItemProps) => {
  return (
    <NavLink to={href} className={getLinkClasses} onClick={onClick}>
      <div className="flex w-full flex-row items-center justify-between">
        <div className="flex w-full flex-row items-center">
          <span className="flex h-6 w-full items-center justify-between text-sm leading-none">{label}</span>
        </div>
      </div>
    </NavLink>
  );
};

export const SecondaryNavigation = ({ linkGroups }: { linkGroups: Array<NavigationLinkGroup> }) => {
  return (
    <div className="flex flex-col pl-4 pt-4 sm:pl-6 md:pl-8" style={{ height: 'var(--content-height)' }}>
      <div className="flex w-64 flex-1 shrink-0 flex-col">
        <div className="flex flex-1 flex-col justify-between overflow-y-auto">
          <div className="flex flex-1 flex-col gap-6">
            {linkGroups.map((linkGroup: NavigationLinkGroup, linkGroupIndex) => (
              <div key={linkGroupIndex}>
                {!!linkGroup.title && (
                  <div className="mb-3 text-xs font-medium uppercase leading-4 text-gray-400">{linkGroup.title}</div>
                )}
                <div className="flex flex-col space-y-1">
                  {linkGroup.links.map((link: NavigationLink) => (
                    <SecondaryNavigationItem href={link.href!} label={link.label} key={link.href} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
